// eslint-disable-next-line import/prefer-default-export
export function useLoginLabels() {
  return {
    adminLogin: 'Admin Login',
    allow: 'Allow',
    changeEmail: 'Change',
    continue: 'Continue',
    email: 'Email',
    emailPlaceholder: 'User Email Address',
    login: 'Login',
    loginToApp: 'Log in to your application using JumpCloud',
    invalidCredentials: 'Please review your login credentials.',
    loginError: 'Please try again, and contact your IT admin if the issue persists.',
    rememberMe: 'Remember me',
    ssoLogin: 'SSO Login',
    userLogin: 'User Login',
    password: 'Password',
    userPasswordPlaceholder: 'User Password',
    resetUserPassword: 'Reset User Password',
    welcomeBack: 'Welcome Back!',
  };
}
